import i18n from 'scoreboard/components/i18n'
import BootslideMenu from 'scoreboard/components/bootslide/bootslide-menu'

function create (widgetModel) {
	return {
		id: 'abbreviate-numbers',
		type: 'toggle',
		label: i18n.get('common.abbreviateNumbers'),
		contentView: BootslideMenu.WidgetToggleProperty.extend({
			property: {
				name: 'showAbbreviatedNumbers',
				label: i18n.get('common.abbreviateNumbers')
			}
		}),
		model: widgetModel.properties
	}
}

export default create

create.__filename__ = 'dashboards/widgets/abbreviate-numbers-option.js'
